const JSSHA = require('jssha');

const isBrowser = () => typeof window !== 'undefined';

const buildApiURL = (url, baseUrl, token, isFrontend = false) => {
    const apiUrlWithTimestamp = `${url + (url.indexOf('?') === -1 ? '?' : '&')}${
        isFrontend ? 'frontend_timestamp' : 'hmac_timestamp'
    }=${Number.parseInt(new Date().getTime() / 1000)}`;

    const shaObj = new JSSHA('SHA-1', 'TEXT');
    shaObj.setHMACKey(token, 'TEXT');
    shaObj.update(apiUrlWithTimestamp);

    return `${baseUrl + apiUrlWithTimestamp}&${isFrontend ? 'frontend_sign' : 'hmac_sign'}=${shaObj.getHMAC('HEX')}`;
};

const getRandomItems = (arr, count) => {
    const shuffled = arr.slice(0);
    let i = arr.length;
    const min = i - count;
    let temp;
    let index;

    while (i > min) {
        index = Math.floor((i + 1) * Math.random());
        temp = shuffled[index];
        shuffled[index] = shuffled[i];
        shuffled[i] = temp;
        i -= 1;
    }

    return shuffled.slice(min);
};

module.exports = { buildApiURL, getRandomItems, isBrowser };
